import {Checkout} from "../Checkout/Checkout";
import { useLocation,useSearchParams } from "react-router-dom";
export const AuthorizeWithCrdx = () => {
    const location = useLocation();
    const mitigationAction = location.pathname.split('/');
    const [searchParams] = useSearchParams();
    const token = searchParams.get('id');
    const dp = searchParams.get('dp');
    const tla = searchParams.get('tla');
    const atz = searchParams.get('atz');
    const src = searchParams.get('src');
    const curr = searchParams.get('curr');
    const pspId = searchParams.get('pspId');
    const offerName = searchParams.get('name');
    const productId = searchParams.get('pId');
    const setupPeriod = searchParams.get('sp');
    const businessTermsBeforeParsing = searchParams.get('bt').replace(/\\/g, '');
    const businessTerms = JSON.parse(businessTermsBeforeParsing);

    return (
        <div>
            <Checkout mitigationAction={mitigationAction[1]} token={token} dp={dp} tla={tla} atz={atz} src={src} curr={curr} pspId={pspId} offerName={offerName} productId={productId} setupPeriod={setupPeriod} businessTermsProp={businessTerms}/>
        </div>
    )
}